import { Supplier } from '@models/account/supplier.model';

import { ApiAdapter } from './adapter';

export class SupplierAdapter extends ApiAdapter<Supplier> {
  get(json): Supplier {
    return new Supplier({
      id: json['id'],
      supplierEntity: json['supplier_code'],
      supplierSubEntity: json['subentity_code'],
    });
  }
}
